export const defaultPlantCapacityOptions = [
  { name: "5KW", value: "P5KW" },
  { name: "10KW", value: "P10KW" },
  { name: "15KW", value: "P15KW" },
  { name: "20KW", value: "P20KW" },
];

/** API enum names (P5KW) ↔ numeric values used in SLN_RequestInfo. */
export const PLANT_CAPACITY_NAME_TO_NUMBER = {
  P5KW: 5,
  P10KW: 10,
  P15KW: 15,
  P20KW: 20,
};

export const PLANT_CAPACITY_NUMBER_TO_NAME = {
  5: "P5KW",
  10: "P10KW",
  15: "P15KW",
  20: "P20KW",
};

export const parsePlantCapacityForApi = (value) => {
  if (value == null || value === "") return null;
  const num = Number(value);
  if (!Number.isNaN(num) && num > 0) return num;
  const key = String(value).trim().toUpperCase();
  return PLANT_CAPACITY_NAME_TO_NUMBER[key] ?? null;
};

export const normalizePlantCapacityOptions = (raw) =>
  (Array.isArray(raw) ? raw : []).map((item) => ({
    name: item?.name ?? item?.Name ?? "",
    value: String(item?.value ?? item?.Value ?? ""),
  }));

/** Unwrap SLN/Customer/Requests GetById(0) enum payload from ApiResult wrappers. */
export const unwrapCustomerRequestFormEnums = (apiResult) => {
  if (!apiResult || apiResult.isSuccess === false || apiResult.IsSuccess === false) {
    return {};
  }

  const payload = apiResult.data ?? apiResult.Data ?? apiResult;
  if (!payload || typeof payload !== "object") return {};

  if (payload.plantCapacity || payload.PlantCapacity) return payload;

  const nested = payload.data ?? payload.Data;
  if (nested && typeof nested === "object") return nested;

  return payload;
};

export const resolvePlantCapacityOptions = (apiResult) => {
  const enums = unwrapCustomerRequestFormEnums(apiResult);
  const normalized = normalizePlantCapacityOptions(
    enums.plantCapacity ?? enums.PlantCapacity
  );
  return normalized.length ? normalized : defaultPlantCapacityOptions;
};
